<template>
  <mdb-container>
    <div v-if="currentGroup">
      <banner-small :group="currentGroup" title="All Activity"/>
    </div>
    <div class="mdb-feed text-left" v-if="currentGroup && activity">
      <div class="news" v-bind:key="item.id" v-for="item in activity" v-if="item.display">
        <div class="label">
          <gp-avatar :avatar="item.image" :memberId="item.memberId" container-class=""/>
        </div>
        <div class="excerpt">
          <div class="brief">
            <div class="message-text">{{item.message}}
              <span class="text-black-50">
                  <mdb-icon icon="clock"/>
                  {{item.agoTime}}
                  </span>
            </div>
            <div v-if="item.linkNew">
              <router-link :to="item.linkNew">{{item.linkText}}</router-link>
            </div>
          </div>
        </div>
        <div style="clear:both;"/>
      </div>
    </div>
    <mdb-pagination circle v-if="pages>1">
      <mdb-page-item @click.native="navTo(1)" v-if="pages > 10 && pageRange[0] != 1">First</mdb-page-item>
      <mdb-page-item :active="n == currentPage" @click.native="navTo(n)" v-bind:key="n" v-for="n in pageRange">{{n}}
      </mdb-page-item>
      <mdb-page-item @click.native="navTo(pages)" v-if="pages > 10 && pageRange[9] != pages">Last</mdb-page-item>
    </mdb-pagination>

  </mdb-container>

</template>
<script>
  import api from '../../services/groupsPlaceApi.js'
  import bannerSmall from '../group/BannerSmall'
  import {mapState} from 'vuex'
  import gpAvatar from "../common/Avatar";
  import {
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbContainer,
    mdbIcon,
    mdbInput,
    mdbPageItem,
    mdbPagination,
    mdbTabs,
  } from 'mdbvue';

  export default {
    name: "group-events",
    components: {
      mdbBtn,
      mdbContainer,
      mdbIcon,
      mdbTabs,
      mdbCard,
      mdbCardHeader,
      mdbCardBody,
      bannerSmall,
      mdbPagination,
      mdbPageItem,
      mdbInput,
      gpAvatar
    },
    computed: mapState({
                         currentGroup: state => state.currentGroup
                       }),
    data() {
      return {
        activity: [],
        totalCount: 0,
        pageRange: [],
        pages: 0,
        currentPage: 1
      }
    },
    mounted() {
      document.title = "All Activity"
      if (this.currentGroup) this.loadData(0)
      else {
        this.loadGroup()
      }
    },
    methods: {
      async loadGroup() {
        await api.groupBasics(this.$route.params.id, "member")
        if (this.currentGroup) this.loadData(0)
        else this.$router.push("/403")
      },
      navTo : function(n) {
        this.currentPage = n
        let offset = (n - 1) * 25
        this.loadData(offset)
        window.scrollTo(0, 0)
      },
      loadData(offset) {
        this.$store.dispatch("setExecuting", true)
        api.get("/group/activity/" + this.currentGroup.id + "?pagination=true&max=25&offset=" + offset).then(
          (results) => {
            this.activity = results.data.activities
            this.totalCount = results.data.totalCount
            this.calculatePagination()
          },
          (error) => {
            this.$notify.error({message: error.response.data, timeOut: 20000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })
      },
      calculatePagination : function() {
        if (this.pages == 1) return
        this.pageRange = []
        if (this.totalCount <= 25) this.pages = 1
        else {
          this.pages = Math.round(this.totalCount / 25)
          if ( (this.pages*25) < this.totalCount ) this.pages++
        }
        let rangeStart = 0
        if (this.pages <= 10) {
          rangeStart = 1
        } else {
          rangeStart = this.currentPage - 1
          if (rangeStart + 10 > this.pages) rangeStart = this.pages - 9
        }
        if (rangeStart < 1) rangeStart = 1
        let max = (this.pages > 10 ? 10 : this.pages)
        for (let i = 0; i < max; i++) {
          const p = i + rangeStart
          if (p <= this.pages) this.pageRange.push(p)
        }
      }
    }
  };

</script>

<style scoped>

  .message-text {
    font-size: .9em;
    line-height: 1 !important;
  }

  .flush-right {
    position: absolute;
    right: 0;
    padding-right: 5px;
  }

  .clickable {
    cursor: pointer;
  }
</style>
